import {Component, OnInit} from '@angular/core';
import {MoedasService} from "./moedas.service";
import {MoedasModel} from "./moedas.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-moedas',
  templateUrl: './moedas.component.html'
})
export class MoedasComponent extends Components implements OnInit {

  moedas: MoedasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private moedasService: MoedasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'moedas'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.moedasService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.moedas = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.moedas);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(moeda) {
    let moedas = this.moedas;
    let moedasService = this.moedasService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarMoeda')+moeda.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(moedas);
        }

        let index = moedas.indexOf(moeda);
        moedas.splice(index, 1);

        moedasService.apagar(moeda.id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              this.moedas = moedas;
            },
            err => {
              // Revert the view back to its original state
              moedas.splice(index, 0, moeda);
              this.moedas = moedas;

              this.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.moedasService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.moedas = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/moedas/moedas.component.ts